export const isMobile = window.innerWidth <= 736;



// WEBPACK FOOTER //
// ./app/lib/responsive.js